import { Performer, PerformerAvatar } from './performer.model';
import { PhotoGroup, MediaGroup, ReviewGroup } from './';

export default function transformPerformer(inputPerformer: any, photos?: PhotoGroup, medias?: MediaGroup, reviews?: ReviewGroup): Performer {
    const performer: any = {};

    for(const key in inputPerformer){

        switch(key){
            case 'advert_numbers':
                performer.advertId = inputPerformer.advert_numbers[0].advertNumber;
                continue;
            case 'roles':
                performer.role = inputPerformer.roles[0];
                continue;
        }

        performer[key] = inputPerformer[key];
    }

    if(photos){
        performer.photos = photos;
    }

    if(medias){
        performer.medias = medias;
    }

    if (reviews){
        performer.reviews = reviews;
    }

    return performer;
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./node_modules/sensejs/performer/performer.transformer.ts